import { FC, HTMLAttributes } from "react"

import { MUIIcon } from "./MUIIcon"
import clsx from "clsx"

interface IBadgeProps extends HTMLAttributes<HTMLSpanElement> {
    text?: string
    icon?: string
    iconClassName?: string
    badgeStyle?: "primary" | "secondary" | "success" | "danger" | "warning" | "error" | "info" | "light" | "dark"
    roundedPill?: boolean
}

export const Badge: FC<IBadgeProps> = ({
    text, icon, iconClassName, roundedPill, className, children, badgeStyle, ...props
}) => {
    const badgeStyleClassName = () => {
        switch (badgeStyle) {
            case "primary": return "badge-primary"
            case "secondary": return "badge-secondary"
            case "success": return "badge-success"
            case "danger": return "badge-danger"
            case "warning": return "badge-warning"
            case "error": return "badge-error"
            case "info": return "badge-info"
            case "light": return "badge-light"
            case "dark": return "badge-dark"
            default: return "badge-light"
        }
    }

    return <span {...props}
        className={clsx(
            "badge",
            badgeStyleClassName(),
            { "rounded-pill": roundedPill },
            className)}>
        {(icon) && <MUIIcon iconName={icon} className={iconClassName} />}
        {text}
        {children}
    </span>
}